import axios from "axios";
import { API_PATHS } from "../../paths";
import SocialMediaItem from "../../Model/SocialMediaModel";
import { flashMessage } from "../../../utils/flashMessageService";

/**
 * GET /api/socialmedia
 */
export async function fetchSocialMedia(payload = {}) {
  try {
    const res = await axios.get(API_PATHS.socialMedia, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: payload,
    });
    const items = res.data || [];
    return items.map((i) => SocialMediaItem.fromJSON(i));
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("fetchSocialMedia failed with status 400:", error.response.data);
      flashMessage(`fetchSocialMedia failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error fetching social media:", error);
      flashMessage("fetchSocialMedia failed. Please try again.", { type: "error" });
    }
    console.error("fetchSocialMedia error:", error);
    throw error;
  }
}

/**
 * POST /api/socialmedia
 */
export async function createSocialMedia(payload = {}) {
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : (() => {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
      return fd;
    })();

    const res = await axios.post(API_PATHS.socialMedia, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    flashMessage("Social media created successfully.", { type: "success" });
    return SocialMediaItem.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("createSocialMedia failed with status 400:", error.response.data);
      flashMessage(`createSocialMedia failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error creating social media:", error);
      flashMessage("createSocialMedia failed. Please try again.", { type: "error" });
    }
    console.error("createSocialMedia error:", error);
    throw error;
  }
}

/**
 * GET /api/socialmedia/:id
 */
export async function fetchSocialMediaById(id) {
  try {
    const res = await axios.get(API_PATHS.socialMediaById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return SocialMediaItem.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error(`fetchSocialMediaById(${id}) failed with status 400:`, error.response.data);
      flashMessage(`fetchSocialMediaById failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error(`Error fetching social media by ID (${id}):`, error);
      flashMessage("fetchSocialMediaById failed. Please try again.", { type: "error" });
    }
    console.error(`fetchSocialMediaById(${id}) error:`, error);
    throw error;
  }
}

/**
 * PUT /api/socialmedia/:id
 */
export async function updateSocialMedia(id, payload = {}) {
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : (() => {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
      return fd;
    })();

    const res = await axios.put(API_PATHS.socialMediaById(id), body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    flashMessage("Social media updated successfully.", { type: "success" });
    return SocialMediaItem.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("updateSocialMedia failed with status 400:", error.response.data);
      flashMessage(`updateSocialMedia failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error updating social media:", error);
      flashMessage("updateSocialMedia failed. Please try again.", { type: "error" });
    }
    console.error(`updateSocialMedia(${id}) error:`, error);
    throw error;
  }
}

/**
 * DELETE /api/socialmedia/:id
 */
export async function deleteSocialMedia(id) {
  try {
    const res = await axios.delete(API_PATHS.socialMediaById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    flashMessage("Social media deleted successfully.", { type: "success" });
    return res.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error(`deleteSocialMedia(${id}) failed with status 400:`, error.response.data);
      flashMessage(`deleteSocialMedia failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error(`Error deleting social media (${id}):`, error);
      flashMessage("deleteSocialMedia failed. Please try again.", { type: "error" });
    }
    console.error(`deleteSocialMedia(${id}) error:`, error);
    throw error;
  }
}
